import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function MascotWelcome({ heading = "Welcome to C.C.C. Auto Electric!", text, badge = "¡Bienvenidos! · Welcome to C.C.C.", size = 190, onCta, ctaLabel = "Describe My Repair" }) {
  return (
    <div className="welcome-strip" data-testid="mascot-welcome-banner">
      <img src="/assets/ccc-mechanic-mascot.png" alt="The friendly C.C.C. Auto Electric mechanic mascot waves hello"
        width={size} height={size} className="mascot-bob" style={{ width: size, height: "auto", flex: "none" }} />
      <div>
        <span className="welcome-badge"><span className="dot" />{badge}</span>
        <h2>{heading}</h2>
        {text && <p>{text}</p>}
        {onCta && (
          <button className="btn btn-blue btn-sm" onClick={onCta} data-testid="mascot-welcome-cta">
            {ctaLabel} <ArrowRight size={14} />
          </button>
        )}
      </div>
    </div>
  );
}

export function MascotTip() {
  return (
    <div className="card" style={{ padding: "18px 22px", display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }} data-testid="mascot-tip">
      <img src="/assets/ccc-mechanic-mascot-portrait.png" alt="" className="mascot-bob" style={{ width: 64, height: 64, objectFit: "contain" }} />
      <div style={{ flex: 1, minWidth: 220 }}>
        <strong style={{ fontFamily: "var(--font-display)" }}>Tip from the shop</strong>
        <p className="muted" style={{ margin: "4px 0 0", fontSize: 14, lineHeight: 1.6 }}>
          Not sure what part is involved? Describe what you see, hear and smell — that is exactly what the intake is for.
        </p>
      </div>
      <Link to="/repair-request" className="btn btn-ghost btn-sm" data-testid="mascot-tip-cta">Describe My Repair</Link>
    </div>
  );
}
